var transparent = "transparent";
var current = "currentColor";
var black = "#000000";
var white = "#FFFFFF";
var success = "#1BA418";
var warning = "#D89C1E";
var error = "#BF2912";
var disabled = "#B9C0D4";
var brand = "#1B6EBB";
var colors = {
	transparent: transparent,
	current: current,
	black: black,
	white: white,
	success: success,
	warning: warning,
	error: error,
	disabled: disabled,
	"disabled-text": "#98A1BE",
	"light-text": "#5A697B",
	"dark-text": "#2B303C",
	brand: brand,
	"brand-ultralight": "#7AB9F4",
	"brand-light": "#3997EF",
	"brand-medium": "#124C81",
	"brand-dark": "#0D2D49",
	"gray-203": "#7296B8",
	"gray-204": "#C8DAEB",
	"gray-205": "#EDEEEF",
	"gray-206": "#F1F4F9",
	"gray-207": "#F7F8FA",
	"gray-208": "#FDFDFF",
	"blue-301": "#033B69",
	"blue-302": "#316797",
	"blue-303": "#538DD3",
	"blue-304": "#93CBFE",
	"blue-305": "#BCDFFD",
	"blue-306": "#E0EDFB",
	"blue-307": "#EBF3FA",
	"blue-308": "#00142566",
	"blue-309": "#001425",
	"compliant-green": "#105F0E",
	"compliant-orange": "#AB4205",
	"compliant-red": "#9D2210",
	"red-50": "#FFF6F5",
	"red-100": "#FCEBE8",
	"red-200": "#FACDC7",
	"red-300": "#F6AFA4",
	"red-400": "#F1806F",
	"red-500": "#ED604B",
	"red-700": "#BF2912",
	"red-900": "#69190C",
	"orange-50": "#FFF9F5",
	"orange-100": "#FDEEE2",
	"orange-200": "#FDD1AE",
	"orange-300": "#FCB071",
	"orange-400": "#FB882A",
	"orange-500": "#E76805",
	"orange-700": "#9B3E08",
	"orange-900": "#592B03",
	"honey-50": "#FFFCF5",
	"honey-100": "#FFF1D1",
	"honey-200": "#FAD97F",
	"honey-300": "#EDC135",
	"honey-400": "#D89C1E",
	"honey-500": "#C77D14",
	"honey-700": "#80450E",
	"honey-900": "#502A0C",
	"lime-50": "#F9FFF0",
	"lime-100": "#ECFAD1",
	"lime-200": "#CDEE86",
	"lime-300": "#A2E538",
	"lime-400": "#76CE12",
	"lime-500": "#5AB60C",
	"lime-700": "#2D7207",
	"lime-900": "#234903",
	"green-50": "#F5FFFA",
	"green-100": "#E0FBEC",
	"green-200": "#B1F1D0",
	"green-300": "#A2E538",
	"green-400": "#1EE67D",
	"green-500": "#1DC36D",
	"green-700": "#2D7207",
	"green-900": "#234903",
	"teal-50": "#F5FEFC",
	"teal-100": "#DAFBF3",
	"teal-200": "#99F6E0",
	"teal-300": "#5FE9D0",
	"teal-400": "#2ED3B7",
	"teal-500": "#15B79E",
	"teal-700": "#107569",
	"teal-900": "#134E48",
	"blue-light-50": "#F5FBFF",
	"blue-light-100": "#E7F5FE",
	"blue-light-200": "#B9E6FE",
	"blue-light-300": "#7CD4FD",
	"blue-light-400": "#36BFFA",
	"blue-light-500": "#0BA5EC",
	"blue-light-700": "#026AA2",
	"blue-light-900": "#0B4A6F",
	"blue-brand-50": "#FAFDFF",
	"blue-brand-100": "#EAF3FD",
	"blue-brand-200": "#C4DFF8",
	"blue-brand-300": "#9ECBF5",
	"blue-brand-400": "#2887E0",
	"blue-brand-500": "#1B6EBB",
	"blue-brand-700": "#134D84",
	"blue-brand-900": "#0F3D69",
	"indigo-50": "#FBFAFF",
	"indigo-100": "#F2F0FF",
	"indigo-200": "#DBD7F9",
	"indigo-300": "#C1BAF5",
	"indigo-400": "#9D91F2",
	"indigo-500": "#8578ED",
	"indigo-700": "#4D3AE4",
	"indigo-900": "#3021A1",
	"purple-50": "#FDFAFF",
	"purple-100": "#F6EDFC",
	"purple-200": "#E9D0F8",
	"purple-300": "#DBB1F4",
	"purple-400": "#C57CF4",
	"purple-500": "#B75FEC",
	"purple-700": "#8D1ED2",
	"purple-900": "#571281",
	"magenta-50": "#FFFAFE",
	"magenta-100": "#FCE9F7",
	"magenta-200": "#FCCAEE",
	"magenta-300": "#FAA5E2",
	"magenta-400": "#F66FCD",
	"magenta-500": "#E750BC",
	"magenta-700": "#B71588",
	"magenta-900": "#7D075C",
	"gray-cool-50": "#F9F9FB",
	"gray-cool-100": "#EFF1F5",
	"gray-cool-200": "#DCDFEA",
	"gray-cool-300": "#B9C0D4",
	"gray-cool-400": "#7D89B0",
	"gray-cool-500": "#5D6B98",
	"gray-cool-700": "#404968",
	"gray-cool-900": "#111322",
	"gray-neutral-50": "#F9FAFB",
	"gray-neutral-100": "#F3F4F6",
	"gray-neutral-150": "#EBEBEB",
	"gray-neutral-200": "#E5E7EB",
	"gray-neutral-300": "#D2D6DB",
	"gray-neutral-400": "#9DA4AE",
	"gray-neutral-500": "#6C737F",
	"gray-neutral-700": "#384250",
	"gray-neutral-900": "#111927"
};

export { black, brand, current, colors as default, disabled, error, success, transparent, warning, white };
